<template>
  <div class="page">
    <div class="content-block">
      <!-- <form-card title="欢迎加入"> -->
        <div class="form">
           <div class="titleBox ">欢迎加入</div>
           <div class="content">
             <el-row>
              <el-col>
                <div class="title">欢迎加入统一链接平台!</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20" :offset="2" :xs="{span:20,offset:2}">
                <div
                  class="content"
                >您的统一链接账号已经注册成功，请尽快登录账号完善资料，以便您能使用统一链接能力。</div>
              </el-col>
            </el-row>
            <div class="btnBox">
              <div class="button cursor" @click="gobackIndex()">回到首页</div>
              <div class="button cursor buttonLogin" @click="goLogin()">立即登录</div>
            </div>
           </div>
         
        </div>
         
      <!-- </form-card> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      agreeStatus: false,
      imgKeyData: {},
      ruleForm: {
        email: "",
        ckey: "",
        imgCaptcha: "",
        emailCaptcha: "",
        password: "",
        passwordConfirm: "",
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    sendCode() {},
    gobackIndex() {
      this.$router.push({
        path: "/",
      });
    },
    goLogin() {
      this.$router.push({
        path: "/account/login",
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-col-17 {
  padding-left: 0px !important;
}
.page {
  background-color: #f8f6f7;
  height: 100%;
  padding: 60px 0px 70px 0px;
  .form {
    width: 1000px;
    margin: 13px auto 131px auto;
    border-radius:12px;
    border: 1px solid rgba(0,0,0,0.1);
    .titleBox {
      background: url("~@/assets/img/account/title-bg.png") no-repeat;
      background-size: 100% 100%;
      height: 161px;
      line-height: 121px;
      text-align: center;
      font-size: 23px;
      font-weight: bold;
      color: #333;
    }
    .content {
      background-color: #fff;
      border-radius: 0px 0px 10px 10px;
      text-align: center;
      padding-bottom: 30px;
    }
  }

  .title {
    font-size: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
  }
  .content {
    font-size: 18px;
    font-weight: 400;
    color: #474747d1;
    line-height: 30px;
    text-align: center;
  }
  .btnBox{
    display: flex;
    width: 100%;
    justify-content: center;
    .button {
      width: 150px;
      margin: 0 20px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      text-align: center;
      margin-top: 53px;
      background: #ccc;
      color: #3a3a3a;
      border-radius:5px;
      // border: 2px solid rgba(58, 58, 58, 1);
      &:hover {
        opacity: .7;
      }
    }
    .buttonLogin{
      color: #fff;
      background: #2E84FC;
    }
  }
  
}
@media screen and (max-width: 767px) {
  .page {
    padding: 0px 0px 70px 0px;
  }
}
</style>